import { enumBrand } from "@coreapp/constants";
import type { GuideDefinition } from "../NativeGuideTypes";
import IsolvedWelcomeGuide from "./IsolvedWelcomeGuide";
import FeatureTourGuide from "./FeatureTourGuide";

/**
 * Registry of all native guides keyed by ID.
 * - `gate` controls visibility (brand, permissions, pathname)
 * - `next` chains to another guide on completion
 * - `Component` is the React component that renders the guide
 * Version bump resurfaces the guide for users who previously dismissed/completed it.
 */
export const guideRegistry: Record<string, GuideDefinition> = {
  "welcome-isolved": {
    id: "welcome-isolved",
    version: 1,
    gate: ({ brand, onboardingNeeded }) => !onboardingNeeded && brand === enumBrand.isolved,
    next: "feature-tour",
    Component: IsolvedWelcomeGuide
  },
  "feature-tour": {
    id: "feature-tour",
    version: 1,
    gate: ({ onboardingNeeded }) => !onboardingNeeded,
    Component: FeatureTourGuide
  }
};
